import { render } from "./Support.vue?vue&type=template&id=af1aace2&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=af1aace2&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1aace2"]])

export default __exports__